import actionTypes from 'constants/actionTypes'

export type ContentGenerationMode = 'convert' | 'generate' | 'edit'
export const DEFAULT_CONTENT_GENERATION_MODE: ContentGenerationMode = 'convert'


export const openContentGenerationModal = () => {
  return {
    type: actionTypes.CONTENT_GENERATION.OPEN_MODAL
  }
}

export const closeContentGenerationModal = () => {
  return {
    type: actionTypes.CONTENT_GENERATION.CLOSE_MODAL
  }
}

export const requestContentGeneration = (mode: ContentGenerationMode = DEFAULT_CONTENT_GENERATION_MODE) => {
  return {
    type: actionTypes.CONTENT_GENERATION.REQUEST,
    mode
  }
}

export const setContentGenerationStatus = (status: string) => {
  return {
    type: actionTypes.CONTENT_GENERATION.SET_STATUS,
    payload: status
  }
}

export const successContentGeneration = () => {
  return {
    type: actionTypes.CONTENT_GENERATION.SUCCESS
  }
}

export const failContentGeneration = () => {
  return {
    type: actionTypes.CONTENT_GENERATION.FAIL
  }
}

export const cancelContentGeneration = () => {
  return {
    type: actionTypes.CONTENT_GENERATION.CANCEL
  }
}
